const APF = {

    state: {
        card: "",           // "" (no add-on) | single | subscription
        quantity: 1,        // single purchase filters
        plan: "ppd",        // ppd (pay per delivery) | prepay
        ppdMonths: 6        // 3 | 6 | 9 | 12
    },

    // line item property for the date, per subscription plan
    DATE_PROPERTY: {
        prepay: "Preferred First Delivery Date",
        ppd: "Preferred First Billing Date"
    },

    datepicker: null,
    adding: false,

    init() {

        this.$root = $(".apf");

        if (!this.$root.length) return;

        this.initDatepicker();
        this.bindEvents();
        this.refresh();

        // Back / swipe-back (mostly mobile) restores this page from the bfcache with
        // its JS state, so `adding` would still be true from the last add to cart
        window.addEventListener("pageshow", event => {
            if (event.persisted) {
                this.adding = false;
            }
        });

    },

    bindEvents() {

        const self = this;
        const $root = this.$root;

        // ============================
        // CARD (click again to remove the add-on)
        // ============================

        $root.on("click", ".apf-card-head", function () {

            const card = $(this).closest(".apf-card").data("card");

            self.state.card = self.state.card === card ? "" : card;

            self.refresh();

        });

        $root.on("keydown", ".apf-card-head", function (event) {

            if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                $(this).trigger("click");
            }

        });

        // ============================
        // SINGLE PURCHASE QUANTITY
        // ============================

        $root.on("click", ".apf-qty-btn", function () {

            self.setQuantity(self.state.quantity + Number($(this).data("step")));

        });

        $root.on("change", ".apf-qty-input", function () {

            self.setQuantity(parseInt(this.value, 10));

        });

        // ============================
        // SUBSCRIPTION
        // ============================

        $root.on("click", ".apf-tab", function () {

            self.state.plan = $(this).data("plan");

            self.refresh();

        });

        $root.on("click", ".apf-month", function () {

            self.state.ppdMonths = Number($(this).data("months"));

            self.refresh();

        });

        // keep the same number of years when switching 3 / 6 months
        $root.on("change", ".apf-prepay-type", function () {

            const years = $root.find(".apf-prepay-plan:not(.hide) option:selected").data("years");
            const $plan = $root.find(`.apf-prepay-plan[data-type="${this.value}"]`);

            $root.find(".apf-prepay-plan").addClass("hide");
            $plan.removeClass("hide");

            const $match = $plan.find(`option[data-years="${years}"]`);
            if ($match.length) {
                $plan.val($match.val());
            }

            self.refresh();

        });

        $root.on("change", ".apf-prepay-plan", function () {

            self.refresh();

        });

    },

    initDatepicker() {

        const input = document.getElementById("apf-delivery-date");

        if (!input) return;

        const { minDate, maxDate } = this.dateRange();

        if (typeof flatpickr === "function") {

            this.datepicker = flatpickr(input, {
                dateFormat: "d/m/Y",
                minDate: minDate,
                maxDate: maxDate,
                disableMobile: true,
                onChange: () => this.toggleDateError(false)
            });

        } else {

            // flatpickr failed to load: fall back to the browser's date picker,
            // which works in yyyy-mm-dd (local date, not UTC)
            const toISO = date => [
                date.getFullYear(),
                String(date.getMonth() + 1).padStart(2, "0"),
                String(date.getDate()).padStart(2, "0")
            ].join("-");

            input.type = "date";
            input.readOnly = false;
            input.min = toISO(minDate);
            input.max = toISO(maxDate);
            input.addEventListener("change", () => this.toggleDateError(false));

        }

    },

    // First delivery from the filter's lead time (custom_fields.lead_time), or tomorrow
    // if that has passed or isn't set; up to 365 days after
    dateRange() {

        const minDate = new Date();
        minDate.setHours(0, 0, 0, 0);
        minDate.setDate(minDate.getDate() + 1);

        const [year, month, day] = (this.$root.attr("data-lead-time") || "").split("-").map(Number);
        const leadTime = year ? new Date(year, month - 1, day) : null;

        if (leadTime && leadTime > minDate) {
            minDate.setTime(leadTime.getTime());
        }

        const maxDate = new Date(minDate);
        maxDate.setDate(maxDate.getDate() + 365);

        return { minDate, maxDate };

    },

    setQuantity(quantity) {

        this.state.quantity = Math.max(1, quantity || 1);

        this.refresh();

    },

    filterPrice() {

        return Number(this.$root.data("filterPrice"));

    },

    prepayOption() {

        return this.$root.find(".apf-prepay-plan:not(.hide) option:selected");

    },

    // Seal pay-per-delivery plan (rendered by filter-ppd-plans); null until the
    // model's subscription product is set up
    ppdPlan() {

        return this.$root.find(`.ppd-plan[data-months="${this.state.ppdMonths}"]`)[0] || null;

    },

    formatMoney(cents) {

        return theme.Currency.formatMoney(cents).replace(".00", "");

    },

    refresh() {

        const state = this.state;
        const $root = this.$root;

        // ==========================================
        // CARDS
        // ==========================================

        $root.find(".apf-card").each(function () {

            const selected = $(this).data("card") === state.card;

            $(this).toggleClass("selected", selected);
            $(this).find(".apf-card-head").attr("aria-checked", selected);

        });

        // ==========================================
        // SINGLE PURCHASE
        // ==========================================

        $root.find(".apf-qty-input").val(state.quantity);
        $root.find(".apf-subtotal-value").text(this.formatMoney(this.filterPrice() * state.quantity));

        // ==========================================
        // SUBSCRIPTION
        // ==========================================

        $root.find(".apf-tab").each(function () {
            $(this).toggleClass("active", $(this).data("plan") === state.plan);
        });

        $root.find(".apf-plan").each(function () {
            $(this).toggleClass("hide", $(this).data("plan") !== state.plan);
        });

        // date wording: delivery date for prepay, billing date + note for pay per delivery
        $root.find(".apf-plan-text").each(function () {
            $(this).toggleClass("hide", $(this).data("plan") !== state.plan);
        });

        // pay per delivery has no extended warranty (prepay only)
        $root.find(".apf-warranty").toggleClass("hide", state.card === "subscription" && state.plan === "ppd");

        // pay per delivery: only offer the frequencies the model's Seal product has
        const ppdMonths = $root.find(".ppd-plan").map((i, el) => Number(el.dataset.months)).get();

        if (ppdMonths.length && !ppdMonths.includes(state.ppdMonths)) {
            state.ppdMonths = ppdMonths[0];
        }

        $root.find(".apf-month").each(function () {
            const months = Number($(this).data("months"));
            $(this).toggleClass("hide", ppdMonths.length > 0 && !ppdMonths.includes(months));
            $(this).toggleClass("active", months === state.ppdMonths);
        });

        $root.find(".apf-ppd-months").text(state.ppdMonths);

        const $subPrice = $root.find(".apf-sub-price");

        if (state.card !== "subscription") {

            $subPrice.text($subPrice.data("from"));

        } else if (state.plan === "prepay") {

            const $option = this.prepayOption();
            const perSet = Math.round(Number($option.data("price")) / Number($option.data("frequency")));

            $subPrice.text(`${this.formatMoney(perSet)}/set`);

        } else {

            // the Seal plan's price, or the one-time price until the model has a Seal product
            const ppd = this.ppdPlan();

            $subPrice.text(`${this.formatMoney(ppd ? Number(ppd.dataset.price) : this.filterPrice())}/set`);

        }

    },

    // ==========================================
    // ADD TO CART (called from bundles.js)
    // ==========================================

    // With an add-on selected, the purifier and the filter are added in one
    // /cart/add.js call: the filter has its own quantity and the subscription
    // carries the delivery date, which the plain cart links can't do.
    handlesCart() {

        return !!this.$root && this.$root.length > 0 && this.state.card !== "";

    },

    // saved on the order as yyyy-mm-dd, e.g. "2026-11-21"
    deliveryDate() {

        if (this.datepicker) {
            const date = this.datepicker.selectedDates[0];
            return date ? this.datepicker.formatDate(date, "Y-m-d") : "";
        }

        // native date input value is already yyyy-mm-dd
        return $("#apf-delivery-date").val() || "";

    },

    toggleDateError(show) {

        this.$root.find(".apf-date-error").toggleClass("hide", !show);
        $("#apf-delivery-date").toggleClass("apf-invalid", show);

    },

    async addToCart(destination) {

        if (this.adding) return;

        const items = [
            {
                id: Number($("#currentSelection").attr("data-variant")),
                quantity: parseInt($("#currentSelection").attr("data-quantity"), 10) || 1
            }
        ];

        const filterVariant = Number(this.$root.data("filterVariant"));

        if (this.state.card === "single") {

            items.push({ id: filterVariant, quantity: this.state.quantity });

        } else {

            const date = this.deliveryDate();

            if (!date) {
                this.toggleDateError(true);
                document.getElementById("apf-delivery-date").scrollIntoView({ behavior: "smooth", block: "center" });
                return;
            }

            const item = {
                id: this.state.plan === "prepay" ? Number(this.prepayOption().val()) : filterVariant,
                quantity: 1,
                properties: { [this.DATE_PROPERTY[this.state.plan]]: date }
            };

            // pay per delivery: the model's Seal subscription variant + selling plan
            // (models without one yet fall back to the one-time filter)
            const ppd = this.state.plan === "ppd" ? this.ppdPlan() : null;

            if (ppd) {
                item.id = Number(ppd.dataset.variant);
                item.selling_plan = Number(ppd.dataset.sellingPlan);
            }

            items.push(item);

        }

        this.adding = true;

        try {

            const response = await fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ items: items })
            });

            if (!response.ok) {
                const error = await response.json().catch(() => ({}));
                throw new Error(error.description || `HTTP ${response.status}`);
            }

            location.href = destination;

        } catch (error) {

            console.error("Failed to add purifier and filter to cart:", error);
            alert("Sorry, we couldn't add this to your cart. " + error.message);
            this.adding = false;

        }

    }

};

$(function () {

    APF.init();

});
